import { ChecklistMetricStatus } from '../../handoff-checklist-v2/handoff-checklist-v2.types';
import { VoiceAirMetricDefinition } from '../voice-air-metrics.types';
import { Feature } from '@weave/schema-gen-ts/dist/shared/feature/location_feature.pb';
import { CustomizationFlagStatesV2 } from 'models/location-feature.model';

export const voiceAirFlagsMetric: VoiceAirMetricDefinition = {
  id: 'voice_air_flags',
  name: 'Voice/AIR Flags',
  isRequired: true,
  criteria: [
    {
      description: 'Enable AI Voice customization flag.',
      whereToFix: {
        label: 'Customization Flag Settings',
        url: (ctx) => `/wam/location/${ctx.locationId}/customization`,
      },
      evaluate: async (ctx) => {
        const feature = ctx.customizationFeatures.find(
          (f) => f.featureEnum === Feature.TRUELARK_AI_VOICE
        );
        const isActive = feature?.state === CustomizationFlagStatesV2.ACTIVE;

        if (!isActive) {
          return {
            status: ChecklistMetricStatus.BLOCKED,
            reason: 'ai_voice_cf_inactive',
            message: 'Enable the "AI Voice" customization flag in WAM settings.',
          };
        }
        return {
          status: ChecklistMetricStatus.PASSED,
          reason: 'air_customization_flags_active',
        };
      },
    },
    {
      description: 'Enable Missed Call Text customization flag.',
      whereToFix: {
        label: 'Customization Flag Settings',
        url: (ctx) => `/wam/location/${ctx.locationId}/customization`,
      },
      evaluate: async (ctx) => {
        const feature = ctx.customizationFeatures.find(
          (f) => f.featureEnum === Feature.AUTO_MISSED_CALL_MESSAGE
        );
        const isActive = feature?.state === CustomizationFlagStatesV2.ACTIVE;

        if (!isActive) {
          return {
            status: ChecklistMetricStatus.BLOCKED,
            reason: 'auto_missed_call_message_cf_inactive',
            message:
              'Enable the "Auto Missed Call Message" customization flag in WAM settings.',
          };
        }
        return {
          status: ChecklistMetricStatus.PASSED,
          reason: 'air_customization_flags_active',
        };
      },
    },
  ],
};
